import './Promo.scss'
import { useSearchParams } from 'react-router'
import { useMemo } from 'react'
import { ImageLoader } from '../../common/ImageLoader'

export const Promo = () => {
  const [searchParams] = useSearchParams()
  const defaultLandingImage = 'https://static.zocks.io/assets/login-page/default.svg'
  const imageUrl = useMemo(() => {
    let landingImage = searchParams.get('landing')
    if (landingImage) {
      landingImage = landingImage.replace(/[^a-zA-Z0-9-_]/g, '')
      return `https://static.zocks.io/assets/login-page/${landingImage}.svg`
    }
    return defaultLandingImage
  }, [searchParams])

  return (
    <div className='promo-container d-none d-lg-block'>
      <div className='promo'>{imageUrl && <ImageLoader src={imageUrl} fallbackSrc={defaultLandingImage} />}</div>
    </div>
  )
}
